export const paths = {
  affiliateForm: "/affiliate-form",
  affiliateProgram: "/affiliate-program",
  affiliateProgramRequest: "/affiliate-program/request",
  analytics: "/analytics",
  auth: "/auth",
  balances: "/balances",
  bankDetailSlug: "/bank-detail/:id",
  checkout: "/checkouts/:id",
  checkouts: "/checkouts",
  confirmOTP: "/confirm-otp",
  convertConfirmation: "/convert-confirmation",
  default: "/",
  deposit: "/deposit/:network/:symbol",
  depositFiat: "/deposit-fiat/:network/:symbol",
  emailPictures: "/test/preview/email-pictures",
  kyb: "/kyb",
  kybInner: "/kyb/:id",
  manualPayouts: "/manual-payouts",
  massPayouts: "/mass-payouts",
  offRamp: "/off-ramp",
  otp: "/settings/otp",
  passwordChange: "/settings/password",
  paymentLinkShow: "/payment-links/:id/show",
  paymentLinks: "/payment-links",
  paymentLinksCreate: "/payment-links/:id",
  payments: "/payments/:id",
  payouts: "/payouts/:id",
  payoutsCard: "/payouts-card/:id",
  payoutsConfirmation: "/payouts/confirmation",
  project: "/projects/:id/show",
  projectUpsert: "/projects/:id",
  projects: "/projects",
  recover: "/recover",
  recoverConfirm: "/recover/confirmed",
  refund: "/refund",
  registration: "/signup",
  registrationConfirm: "/signup/confirmed",
  registrationMerch: "/signup/merchant",
  registrationRef: "/signup/referrer",
  reports: "/reports",
  settings: "/settings",
  statusConfirmation: "/account-confirmation",
  subMerchDetail: "/sub-merch/:id",
  swap: "/swap",
  swapDetails: "/swap/:id",
  thankYou: "/thank-you",
  tokenCreate: "/settings/tokens/:id",
  transactions: "/transactions",
  userForm: "/user-form",
  widgetModify: "/widgets/:id",
  widgets: "/widgets",
  withdraw: "/withdraw/:network/:symbol",
  withdrawDetails: "/withdraw/details",
  withdrawFiat: "/withdraw-fiat/:network/:symbol",
} as const
